/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IFormFile } from '../iFormFile.schema';

export const uploadFilesIncidentRecordsBodyTwoFileFieldTypeIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');

export const UploadFilesIncidentRecordsBody = zod.object({
  "files": zod.array(zod.lazy(() => IFormFile)).optional()
}).and(zod.object({
  "fileFieldTypeId": zod.union([zod.number(),zod.string().regex(uploadFilesIncidentRecordsBodyTwoFileFieldTypeIdRegExpTwo)]).optional()
})).and(zod.object({
  "isSignedDocument": zod.boolean().optional()
})).and(zod.object({
  "sourceUnsignedId": zod.string().uuid().optional()
}))

export type UploadFilesIncidentRecordsBody = zod.input<typeof UploadFilesIncidentRecordsBody>;
export type UploadFilesIncidentRecordsBodyOutput = zod.output<typeof UploadFilesIncidentRecordsBody>;
